import React from 'react';
import { COLORS, FONTS, inputStyle, labelStyle, cardStyle, handleInputFocus, handleInputBlur, primaryButtonStyle, secondaryButtonStyle } from './signupStyles';
import { StepIndicator } from './StepIndicator';
import { CONTACT_PREFERENCES } from './signupData';

const selectStyle = {
  ...inputStyle,
  appearance: 'none',
  backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'12\' height=\'8\' viewBox=\'0 0 12 8\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M1 1L6 6L11 1\' stroke=\'%23666\' stroke-width=\'2\' stroke-linecap=\'round\'/%3E%3C/svg%3E")',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'right 16px center'
};

export const StepPersonalDetails = ({ formData, onUpdate, onNext, onBack }) => {
  const canContinue = formData.firstName && formData.lastName && formData.email && formData.dateOfBirth;

  return (
    <div style={{
      minHeight: '80vh', backgroundColor: COLORS.bg, display: 'flex',
      alignItems: 'center', justifyContent: 'center', padding: '80px 20px 40px', fontFamily: FONTS.system
    }}>
      <style>{`
        @media (max-width: 480px) {
          .signup-personal-card { padding: 32px 24px !important; }
          .signup-name-row { flex-direction: column !important; }
        }
      `}</style>
      <div className="signup-personal-card" style={cardStyle}>
        <StepIndicator currentStep={0} totalSteps={4} stepLabels={['Personal', 'About You', 'Health', 'Done']} />
        <h2 style={{ fontFamily: FONTS.serif, fontSize: '24px', fontWeight: '700', color: COLORS.text, margin: '0 0 8px', textAlign: 'center' }}>
          Personal Details
        </h2>
        <p style={{ fontSize: '15px', color: COLORS.muted, margin: '0 0 28px', textAlign: 'center' }}>
          Tell us a little about yourself
        </p>

        <div className="signup-name-row" style={{ display: 'flex', gap: '12px', marginBottom: '16px' }}>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>First name*</label>
            <input type="text" value={formData.firstName} onChange={(e) => onUpdate({ firstName: e.target.value })}
              style={inputStyle} onFocus={handleInputFocus} onBlur={handleInputBlur} />
          </div>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Last name*</label>
            <input type="text" value={formData.lastName} onChange={(e) => onUpdate({ lastName: e.target.value })}
              style={inputStyle} onFocus={handleInputFocus} onBlur={handleInputBlur} />
          </div>
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label style={labelStyle}>Email*</label>
          <input type="email" value={formData.email} onChange={(e) => onUpdate({ email: e.target.value })}
            placeholder="your@email.com" style={inputStyle} onFocus={handleInputFocus} onBlur={handleInputBlur} />
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label style={labelStyle}>Date of birth*</label>
          <input type="date" value={formData.dateOfBirth} onChange={(e) => onUpdate({ dateOfBirth: e.target.value })}
            style={inputStyle} onFocus={handleInputFocus} onBlur={handleInputBlur} />
        </div>

        <div style={{ marginBottom: '16px' }}>
          <label style={labelStyle}>How would you prefer to be contacted?*</label>
          <select value={formData.contactPreference} onChange={(e) => onUpdate({ contactPreference: e.target.value })}
            style={selectStyle} onFocus={handleInputFocus} onBlur={handleInputBlur}>
            {CONTACT_PREFERENCES.map(c => <option key={c} value={c}>{c}</option>)}
          </select>
        </div>

        <div style={{ marginBottom: '28px' }}>
          <label style={labelStyle}>Phone number</label>
          <input type="tel" value={formData.phone} onChange={(e) => onUpdate({ phone: e.target.value })}
            placeholder="(555) 123-4567" style={inputStyle} onFocus={handleInputFocus} onBlur={handleInputBlur} />
        </div>

        <div style={{ display: 'flex', gap: '12px' }}>
          <button onClick={onBack} style={secondaryButtonStyle}>Back</button>
          <button onClick={onNext} disabled={!canContinue} style={{
            ...primaryButtonStyle,
            flex: 1,
            opacity: canContinue ? 1 : 0.4,
            cursor: canContinue ? 'pointer' : 'not-allowed'
          }}>Continue</button>
        </div>
      </div>
    </div>
  );
};
